import axiosInstance from "../../axiosInstance";
import React, { useState, useEffect } from "react";
import { Modal, Button, Row, Col } from "react-bootstrap";
import { useEnv } from "../../context/EnvContext";

const ScaleModal = ({
  showScaleModal,
  handleScaleClose,
  podInfo,
  apiUrl,
  cluster,
  onScaleSuccess,
}) => {
  const [desiredReplicas, setDesiredReplicas] = useState(podInfo.replicas);
  const { env } = useEnv() || {};

  const replicaName =
    podInfo.pod_name.split("-").slice(0, -1).join("-") || "Unknown";

  // Reset desiredReplicas when modal closes
  useEffect(() => {
    if (showScaleModal) {
      setDesiredReplicas(podInfo.replicas);
    }
  }, [showScaleModal, podInfo.replicas]);

  const handleRangeChange = (e) => {
    setDesiredReplicas(parseInt(e.target.value));
  };

  const handleScaleConfirm = async () => {
    // Handle missing data
    if (!env || !podInfo?.deployment) {
      console.error("Missing required data for scaling");
      return;
    }

    console.log("Scaling deployment for deployment:", podInfo.deployment);
    // Call API to scale the replicas for the given deployment
    try {
      const response = await axiosInstance.get(
        `/scale-deployment?cluster=${cluster}&namespace=238240-${env}&deploymentName=${podInfo.deployment}&replicas=${desiredReplicas}`
      );
      console.log("Pod restarted:", response.data);
      handleScaleClose();
      if (onScaleSuccess) {
        onScaleSuccess(); // Call the refresh function after successful restart
      }
    } catch (error) {
      console.error("Failed to restart pod:", error);
    }
  };

  return (
    <Modal
      show={showScaleModal}
      onHide={handleScaleClose}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header>
        <Modal.Title>Scale Replica: {replicaName}</Modal.Title>
        <i
          className="fas fa-times"
          style={{ cursor: "pointer" }}
          onClick={handleScaleClose}
          title="Close"
        ></i>
      </Modal.Header>
      <Modal.Body>
        {/* Adjustable dial to scale pod - minimum 1, maximum 10 (for now) */}
        <Row>
          <label htmlFor="scale">Scale replicas:</label>
          <input
            type="range"
            className="form-range"
            min="1"
            max="10"
            step="1"
            value={desiredReplicas}
            onChange={handleRangeChange}
          />
        </Row>
        <Row>
          <Col md={6}>
            <p>Current replicas: {podInfo?.replicas || "Loading..."}</p>
          </Col>
          <Col md={6} className="text-end">
            <p>Desired replicas: {desiredReplicas}</p>
          </Col>
        </Row>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleScaleClose}>
          Cancel
        </Button>
        <Button variant="primary" onClick={handleScaleConfirm}>
          Scale
        </Button>
      </Modal.Footer>

      {/* On clicking scale, show confirmation pop-up */}
    </Modal>
  );
};

export default ScaleModal;
